import axios from '../axiosConfig'; // Assuming this is your configured Axios instance
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;

  const getOEMList = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    const authToken = localStorage.getItem('access_token');
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
  
    try {
      const response = await axios.get('/oem/list?page='+data.page+'&per_page='+data.per_page+'&search_content='+data.search+'&category='+data.category, {
        headers: headers
      });
      console.log(response);
       
      return response;
    } catch (error) { 
      return error;
    }
  }; 

  const getOEMListOpen = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    const authToken = localStorage.getItem('access_token');
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
  
    try {
      const response = await axios.get('/oem/list/open?page='+data.page+'&per_page='+data.per_page+'&search_content='+data.search+'&category='+data.category, {
        headers: headers
      });
      console.log(response);
       
      return response;
    } catch (error) { 
      return error;
    }
  }; 
  
  const getOEMById = async (id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    const authToken = localStorage.getItem('access_token');
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
  
    try {
      const response = await axios.get(`/oem/single/${id}`, {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) { 
      return error;
    }
  }; 

  const addOEM = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    const authToken = localStorage.getItem('access_token');
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
  
    try {
      const response = await axios.post('/oem/add', data, {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) { 
      return error;
    }
  }; 
    const updateOEM = async (id, data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    const authToken = localStorage.getItem('access_token');
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    } 
    try {
      const response = await axios.put(`/oem/update/${id}`, data, {
        headers: headers 
      })  
      return response;
    } 
    catch (error) { 
      return error; 
    }
  }

  const favorite = async (id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    const authToken = localStorage.getItem('access_token');
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
  
    try {
      const response = await axios.post(`/oem/favorite/${id}`, {}, {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) { 
      return error;
    }
  }; 
  const removeFavorite = async (id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    const authToken = localStorage.getItem('access_token');
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`;
    }
  
    try {
      const response = await axios.post(`/oem/favorite/remove/${id}`, {}, {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) { 
      return error;
    }
  }; 
  export { getOEMList, getOEMListOpen, getOEMById ,addOEM,updateOEM,favorite,removeFavorite,baseURL};